import React from 'react';
import { Grid, Box, Card, Stack, Typography, Divider } from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';
import Logo from 'src/layouts/full/shared/logo/Logo';
import DoneIcon from '@mui/icons-material/Done';

const AuthGoogleSuccess = () => {
  return (
    <PageContainer title="WATS - google calendar">
      <Box
        sx={{
          position: 'relative',
          '&:before': {
            content: '""',
            background: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
            backgroundSize: '400% 400%',
            animation: 'gradient 15s ease infinite',
            position: 'absolute',
            height: '100%',
            width: '100%',
            opacity: '0.3',
          },
        }}
      >

        <Grid container spacing={0} justifyContent="center" sx={{ height: '100vh' }}>
          <Grid
            item
            xs={12}
            sm={12}
            lg={5}
            xl={4}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >

            <Card elevation={9} sx={{ p: 4, zIndex: 1, width: '90%', maxWidth: '450px' }}>
              <Box display="flex" alignItems="center" justifyContent="center" >
                <Logo />
              </Box>


              <Box display="flex" alignItems="center" justifyContent="center">
                <DoneIcon style={{fontSize: '70px', color: 'green'}}/><br></br>
              </Box>


              <Box display="flex" alignItems="center" justifyContent="center">
                <Typography fontWeight="400" variant="h4" mb={1}>
                  تم إنشاء الرزنامة بنجاح
                </Typography>
              </Box>

              


            </Card>
          </Grid>
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default AuthGoogleSuccess;
